import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "property-card__image lazy-image__wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "property-card__text" }
const _hoisted_4 = { class: "property-card__text-title" }
const _hoisted_5 = { class: "property-card__text-group mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "property-card__text-price"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "property-card",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openProperty && _ctx.openProperty(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "lazy-image",
        src: _ctx.property.background_image,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "property-card__tags" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.property.name), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.property.city) + ", " + _toDisplayString(_ctx.property.state), 1),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "font-weight-bold" }, "$128", -1),
            _createTextVNode(" / month ")
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "property-card__text-description",
        innerHTML: _ctx.property.general_info
      }, null, 8, _hoisted_7)
    ])
  ]))
}